<template>
  <div class="park_payment">
    <div class="tit">
      <span>园区缴费</span>
    </div>
    <div class="body_content">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="isCertified == 1">
        <el-tab-pane label="租金" name="0">
          <paymentItem
            :tableObj1="tableObj0.tableObj1"
            :tableObj2="tableObj0.tableObj2"
            @getList="getList"
          ></paymentItem>
        </el-tab-pane>
        <el-tab-pane label="物业费" name="1">
          <paymentItem
            :tableObj1="tableObj1.tableObj1"
            :tableObj2="tableObj1.tableObj2"
            @getList="getList"
          ></paymentItem>
        </el-tab-pane>
        <el-tab-pane label="水费" name="2">
          <paymentItem
            :tableObj1="tableObj2.tableObj1"
            :tableObj2="tableObj2.tableObj2"
            @getList="getList"
          ></paymentItem>
        </el-tab-pane>
        <el-tab-pane label="电费" name="3">
          <paymentItem
            :tableObj1="tableObj3.tableObj1"
            :tableObj2="tableObj3.tableObj2"
            @getList="getList"
          ></paymentItem>
        </el-tab-pane>
        <el-tab-pane label="加班费" name="4">
          <paymentItem
            :tableObj1="tableObj4.tableObj1"
            :tableObj2="tableObj4.tableObj2"
            @getList="getList"
          ></paymentItem>
        </el-tab-pane>
        <el-tab-pane label="打印费" name="5">
          <paymentItem
            :tableObj1="tableObj5.tableObj1"
            :tableObj2="tableObj5.tableObj2"
            @getList="getList"
          ></paymentItem>
        </el-tab-pane>
        <el-tab-pane label="场所费" name="6">
          <paymentItem
            :tableObj1="tableObj6.tableObj1"
            :tableObj2="tableObj6.tableObj2"
            @getList="getList"
          ></paymentItem>
        </el-tab-pane>
      </el-tabs>
      <div class="btns" v-if="isCertified === 2">
        <div class="btn_left">
          <el-button type="primary" @click="toEmployeeCertify">认证为员工</el-button>
          <el-button type="primary" @click="toEnterpriseCertify">认证为企业</el-button>
        </div>
      </div>
      <div class="message" v-if="isCertified === 3">
        <p>此页面数据仅企业身份可看</p>
      </div>
    </div>
  </div>
</template>

<script>
import paymentItem from "@/components/park_payment/park_payment.vue";
export default {
  components: {
    paymentItem
  },
  data() {
    return {
      tableObj0: {
        tableObj1: {
          //列表数据
          list: [],
          btns: [
            //按钮组
            // {
            //   name: "去缴费",
            //   funcName: "toPay"
            // },
            {
              name: "上传凭证",
              funcName: "uploadCertificate",
              formatter: function(row) {
                return row.status_code === "IdentityCertifieStatusSubmitted";
              }
            }
          ],
          table_detail: [
            //table详情
            {
              prop: "name",
              label: "租赁场所"
            },
            {
              prop: "area",
              label: "场地面积",
              formatter: row => {
                return `<span>${row.area}m²</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                if (row.money === "面议") {
                  return `<span>${row.money}</span>`;
                } else {
                  return `<span>${row.money}元/月</span>`;
                }
              }
            },
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "total_money",
              label: "应缴金额",
              formatter: row => {
                if (row.total_money === "面议") {
                  return `<span>${row.total_money}</span>`;
                } else {
                  return `<span>${row.total_money}元</span>`;
                }
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "status_name",
              label: "缴费状态",
              formatter: function(row) {
                if (row.status_code === "IdentityCertifieStatusInReview") {
                  return `<span class="">
                   已支付 
                </span>`;
                } else if (
                  row.status_code === "IdentityCertifieStatusSubmitted"
                ) {
                  return `<span class="">
                   待支付 
                </span>`;
                } else {
                  return `<span class="">
                   ${row.status_name}
                </span>`;
                }
              }
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 3,
            hide: true
          }
        },
        tableObj2: {
          //列表数据
          list: [],
          btns: [
            //按钮组
          ],
          table_detail: [
            //table详情
            {
              prop: "name",
              label: "租赁场所"
            },
            {
              prop: "area",
              label: "场地面积",
              formatter: row => {
                return `<span>${row.area}m²</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                if (row.money === "面议") {
                  return `<span>${row.money}</span>`;
                } else {
                  return `<span>${row.money}元/月</span>`;
                }
              }
            },
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "paid_money",
              label: "实缴金额",
              formatter: row => {
                if (row.paid_money === "面议") {
                  return `<span>${row.paid_money}</span>`;
                } else {
                  return `<span>${row.paid_money}元</span>`;
                }
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "paid_date",
              label: "实缴时间",
              width: "85"
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 3,
            hide: true
          }
        }
      },
      tableObj1: {
        tableObj1: {
          //列表数据
          list: [],
          btns: [
            //按钮组
            // {
            //   name: "去缴费",
            //   funcName: "toPay"
            // },
            {
              name: "上传凭证",
              funcName: "uploadCertificate",
              formatter: function(row) {
                return row.status_code === "IdentityCertifieStatusSubmitted";
              }
              // formatter: function(row) {
              //   return row.status_name == "已提交";
              // }
            }
          ],
          table_detail: [
            //table详情
            {
              prop: "name",
              label: "租赁场所"
            },
            {
              prop: "area",
              label: "场地面积",
              formatter: row => {
                return `<span>${row.area}m²</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                if (row.money === "面议") {
                  return `<span>${row.money}</span>`;
                } else {
                  return `<span>${row.money}元/月</span>`;
                }
              }
            },
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "total_money",
              label: "应缴金额",
              formatter: row => {
                if (row.total_money === "面议") {
                  return `<span>${row.total_money}</span>`;
                } else {
                  return `<span>${row.total_money}元</span>`;
                }
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "status_name",
              label: "缴费状态",
              formatter: function(row) {
                if (row.status_code === "IdentityCertifieStatusInReview") {
                  return `<span class="">
                   已支付 
                </span>`;
                } else if (
                  row.status_code === "IdentityCertifieStatusSubmitted"
                ) {
                  return `<span class="">
                   待支付 
                </span>`;
                } else {
                  return `<span class="">
                   ${row.status_name}
                </span>`;
                }
              }
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5
          }
        },
        tableObj2: {
          //列表数据
          list: [],
          btns: [
            //按钮组
          ],
          table_detail: [
            //table详情
            {
              prop: "name",
              label: "租赁场所"
            },
            {
              prop: "area",
              label: "场地面积",
              formatter: row => {
                return `<span>${row.area}m²</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                if (row.money === "面议") {
                  return `<span>${row.money}</span>`;
                } else {
                  return `<span>${row.money}元/月</span>`;
                }
              }
            },
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "paid_money",
              label: "实缴金额",
              formatter: row => {
                if (row.paid_money === "面议") {
                  return `<span>${row.paid_money}</span>`;
                } else {
                  return `<span>${row.paid_money}元</span>`;
                }
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "paid_date",
              label: "实缴时间",
              width: "85"
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        }
      },
      tableObj2: {
        tableObj1: {
          //列表数据
          list: [],
          btns: [
            //按钮组
            // {
            //   name: "去缴费",
            //   funcName: "toPay"
            // },
            {
              name: "上传凭证",
              funcName: "uploadCertificate",
              formatter: function(row) {
                return row.status_code === "IdentityCertifieStatusSubmitted";
              }
            }
          ],
          table_detail: [
            //table详情
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                return `<span>${row.money}元/吨</span>`;
              }
            },
            {
              prop: "this_month_num",
              label: "本月读数",
              formatter: row => {
                return `<span>${row.this_month_num}吨</span>`;
              }
            },
            {
              prop: "last_month_num",
              label: "上月读数",
              formatter: row => {
                return `<span>${row.last_month_num}吨</span>`;
              }
            },
            {
              prop: "nums",
              label: "使用数量",
              formatter: row => {
                return `<span>${row.this_month_num -
                  row.last_month_num}吨</span>`;
              }
            },
            {
              prop: "total_money",
              label: "应缴金额",
              formatter: row => {
                return `<span>${row.total_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "status_name",
              label: "缴费状态",
              formatter: function(row) {
                if (row.status_code === "IdentityCertifieStatusInReview") {
                  return `<span class="">
                   已支付 
                </span>`;
                } else if (
                  row.status_code === "IdentityCertifieStatusSubmitted"
                ) {
                  return `<span class="">
                   待支付 
                </span>`;
                } else {
                  return `<span class="">
                   ${row.status_name}
                </span>`;
                }
              }
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5
          }
        },
        tableObj2: {
          //列表数据
          list: [],
          btns: [
            //按钮组
          ],
          table_detail: [
            //table详情

            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                return `<span>${row.money}元/吨</span>`;
              }
            },
            {
              prop: "this_month_num",
              label: "本月读数",
              formatter: row => {
                return `<span>${row.this_month_num}吨</span>`;
              }
            },
            {
              prop: "last_month_num",
              label: "上月读数",
              formatter: row => {
                return `<span>${row.last_month_num}吨</span>`;
              }
            },
            {
              prop: "",
              label: "使用数量",
              formatter: row => {
                return `<span>${row.this_month_num -
                  row.last_month_num}吨</span>`;
              }
            },
            {
              prop: "paid_money",
              label: "实缴金额",
              formatter: row => {
                return `<span>${row.paid_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "paid_date",
              label: "实缴时间",
              width: "85"
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        }
      },
      tableObj3: {
        tableObj1: {
          //列表数据
          list: [],
          btns: [
            //按钮组
            // {
            //   name: "去缴费",
            //   funcName: "toPay"
            // },
            {
              name: "上传凭证",
              funcName: "uploadCertificate",
              formatter: function(row) {
                return row.status_code === "IdentityCertifieStatusSubmitted";
              }
            }
          ],
          table_detail: [
            //table详情
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                return `<span>${row.money}元/度</span>`;
              }
            },
            {
              prop: "this_month_num",
              label: "本月读数",
              formatter: row => {
                return `<span>${row.this_month_num}度</span>`;
              }
            },
            {
              prop: "last_month_num",
              label: "上月读数",
              formatter: row => {
                return `<span>${row.last_month_num}度</span>`;
              }
            },
            {
              prop: "",
              label: "使用数量",
              formatter: row => {
                return `<span>${row.this_month_num -
                  row.last_month_num}度</span>`;
              }
            },
            {
              prop: "total_money",
              label: "应缴金额",
              formatter: row => {
                return `<span>${row.total_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "status_name",
              label: "缴费状态",
              formatter: function(row) {
                if (row.status_code === "IdentityCertifieStatusInReview") {
                  return `<span class="">
                   已支付 
                </span>`;
                } else if (
                  row.status_code === "IdentityCertifieStatusSubmitted"
                ) {
                  return `<span class="">
                   待支付 
                </span>`;
                } else {
                  return `<span class="">
                   ${row.status_name}
                </span>`;
                }
              }
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5
          }
        },
        tableObj2: {
          //列表数据
          list: [],
          btns: [
            //按钮组
          ],
          table_detail: [
            //table详情

            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                return `<span>${row.money}元/度</span>`;
              }
            },
            {
              prop: "",
              label: "本月读数",
              formatter: row => {
                return `<span>${row.this_month_num}度</span>`;
              }
            },
            {
              prop: "",
              label: "上月读数",
              formatter: row => {
                return `<span>${row.last_month_num}度</span>`;
              }
            },
            {
              prop: "",
              label: "使用数量",
              formatter: row => {
                return `<span>${row.this_month_num -
                  row.last_month_num}吨</span>`;
              }
            },
            {
              prop: "paid_money",
              label: "实缴金额",
              formatter: row => {
                return `<span>${row.paid_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "paid_date",
              label: "实缴时间",
              width: "85"
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        }
      },
      tableObj4: {
        tableObj1: {
          //列表数据
          list: [],
          btns: [
            //按钮组
            // {
            //   name: "去缴费",
            //   funcName: "toPay"
            // },
            {
              name: "上传凭证",
              funcName: "uploadCertificate",
              formatter: function(row) {
                return row.status_code === "IdentityCertifieStatusSubmitted";
              }
            }
          ],
          table_detail: [
            //table详情
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                return `<span>${row.money}元/小时</span>`;
              }
            },
            {
              prop: "nums",
              label: "使用数量",
              formatter: function(row) {
                return `<span class="">${new Date(row.end_date).getHours() -
                  new Date(row.start_date).getHours()}小时</span>`;
              }
            },
            {
              prop: "total_money",
              label: "应缴金额",
              formatter: row => {
                return `<span>${row.total_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "status_name",
              label: "缴费状态",
              formatter: function(row) {
                if (row.status_code === "IdentityCertifieStatusInReview") {
                  return `<span class="">
                   已支付 
                </span>`;
                } else if (
                  row.status_code === "IdentityCertifieStatusSubmitted"
                ) {
                  return `<span class="">
                   待支付 
                </span>`;
                } else {
                  return `<span class="">
                   ${row.status_name}
                </span>`;
                }
              }
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        },
        tableObj2: {
          //列表数据
          list: [],
          btns: [
            //按钮组
          ],
          table_detail: [
            //table详情
            {
              prop: "name",
              label: "租赁场所"
            },
            {
              prop: "meeting_type_name",
              label: "场所类型"
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                return `<span>${row.money}元/小时</span>`;
              }
            },
            {
              prop: "nums",
              label: "使用数量",
              formatter: row => {
                return `<span>${row.nums}小时</span>`;
              }
            },
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "paid_money",
              label: "实缴金额",
              formatter: row => {
                return `<span>${row.paid_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "paid_date",
              label: "实缴时间"
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        }
      },
      tableObj5: {
        tableObj1: {
          //列表数据
          list: [],
          btns: [
            //按钮组
            // {
            //   name: "去缴费",
            //   funcName: "toPay"
            // },
            {
              name: "上传凭证",
              funcName: "uploadCertificate",
              formatter: function(row) {
                return row.status_code === "IdentityCertifieStatusSubmitted";
              }
            }
          ],
          table_detail: [
            //table详情
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: function(row) {
                return `<span class="">${row.money}元/张</span>`;
              }
            },

            {
              prop: "nums",
              label: "使用数量",
              formatter: function(row) {
                return `<span class="">${row.nums}张</span>`;
              }
            },
            {
              prop: "total_money",
              label: "应缴金额",
              formatter: function(row) {
                return `<span class="">${row.total_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "status_name",
              label: "缴费状态",
              formatter: function(row) {
                if (row.status_code === "IdentityCertifieStatusInReview") {
                  return `<span class="">
                   已支付 
                </span>`;
                } else if (
                  row.status_code === "IdentityCertifieStatusSubmitted"
                ) {
                  return `<span class="">
                   待支付 
                </span>`;
                } else {
                  return `<span class="">
                   ${row.status_name}
                </span>`;
                }
              }
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5
          }
        },
        tableObj2: {
          //列表数据
          list: [],
          btns: [
            //按钮组
          ],
          table_detail: [
            //table详情

            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: function(row) {
                return `<span class="">${row.money}元/张</span>`;
              }
            },
            {
              prop: "nums",
              label: "使用数量",
              formatter: function(row) {
                return `<span class="">${row.nums}张</span>`;
              }
            },
            {
              prop: "paid_money",
              label: "实缴金额",
              formatter: function(row) {
                return `<span class="">${row.paid_money}元</span>`;
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "paid_date",
              label: "实缴时间",
              width: "85"
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        }
      },
      tableObj6: {
        tableObj1: {
          //列表数据
          list: [],
          btns: [
            //按钮组
            // {
            //   name: "去缴费",
            //   funcName: "toPay"
            // },
            {
              name: "上传凭证",
              funcName: "uploadCertificate",
              formatter: function(row) {
                return row.status_code === "IdentityCertifieStatusSubmitted";
              }
              // formatter: function(row) {
              //   return row.status_name == "已提交";
              // }
            }
          ],
          table_detail: [
            //table详情
            {
              prop: "name",
              label: "租赁场所"
            },
            {
              prop: "meeting_type_name",
              label: "场地类型"
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                if (row.money === "面议") {
                  return `<span>${row.money}</span>`;
                } else {
                  return `<span>${row.money}元/小时</span>`;
                }
              }
            },
            {
              prop: "nums",
              label: "使用数量",
              formatter: row => {
                return `<span>${row.nums}小时</span>`;
              }
            },
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "total_money",
              label: "应缴金额",
              formatter: row => {
                if (row.total_money === "面议") {
                  return `<span>${row.total_money}</span>`;
                } else {
                  return `<span>${row.total_money}元</span>`;
                }
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "status_name",
              label: "缴费状态",
              formatter: function(row) {
                if (row.status_code === "IdentityCertifieStatusInReview") {
                  return `<span class="">
                   已支付 
                </span>`;
                } else if (
                  row.status_code === "IdentityCertifieStatusSubmitted"
                ) {
                  return `<span class="">
                   待支付 
                </span>`;
                } else {
                  return `<span class="">
                   ${row.status_name}
                </span>`;
                }
              }
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        },
        tableObj2: {
          //列表数据
          list: [],
          btns: [
            //按钮组
          ],
          table_detail: [
            //table详情
            {
              prop: "name",
              label: "租赁场所"
            },
            {
              prop: "meeting_type_name",
              label: "场所类型"
            },
            {
              prop: "money",
              label: "收费标准",
              formatter: row => {
                if (row.money === "面议") {
                  return `<span>${row.money}</span>`;
                } else {
                  return `<span>${row.money}元/小时</span>`;
                }
              }
            },
            {
              prop: "nums",
              label: "使用数量",
              formatter: row => {
                return `<span>${row.nums}小时</span>`;
              }
            },
            {
              prop: "use_date_str",
              label: "账单月份",
              formatter: function(row) {
                return `<span class="">${row.use_date_str}月</span>`;
              }
            },
            {
              prop: "paid_money",
              label: "实缴金额",
              formatter: row => {
                if (row.paid_money === "面议") {
                  return `<span>${row.paid_money}</span>`;
                } else {
                  return `<span>${row.paid_money}元</span>`;
                }
              }
            },
            {
              prop: "pay_date",
              label: "应缴时间",
              width: "85"
            },
            {
              prop: "paid_date",
              label: "实缴时间",
              width: "85"
            }
          ],
          layerpageinfo: {
            //分页
            pageNo: 0,
            total: 0,
            pageSize: 5,
            hid: true
          }
        }
      },
      activeName: "0",
      type: [],
      params: {
        type: "CostTypeRent"
      },
      index: 0,
      isCertified: 0
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if (this.info) {
      this.certified();
    } else {
      this.needInfo("certified");
    }
    this.getDirecties();
  },
  methods: {
    // tab切换事件
    handleClick(tab) {
      // console.log(tab, event);
      this.index = parseInt(tab.name);
      this.params.type = this.type[this.index].code;
      this.getFontCosts(this.index, false);
      this.getFontCosts(this.index, true);
    },
    // 获取缴费类型字典
    getDirecties() {
      this.api
        .getDictionaries({
          typeCode: "CostType",
          pageNo: 0,
          pageSize: 999
        })
        .then(res => {
          // console.log(res);

          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.type = list.length ? list : null;
        });
    },
    //获取缴费列表
    getFontCosts(index, flag) {
      if (flag) {
        var obj = Object.assign(
          {},
          this.params,
          {
            status_codes:
              "IdentityCertifieStatusSubmitted,IdentityCertifieStatusInReview"
          },
          this[`tableObj${this.index}`].tableObj1.layerpageinfo
        );
      } else {
        var obj = Object.assign(
          {},
          this.params,
          {
            status_codes: "IdentityCertifieStatussuccess"
          },
          this[`tableObj${this.index}`].tableObj2.layerpageinfo
        );
      }

      this.api.getFontCosts(obj).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        if (flag) {
          this[`tableObj${index}`].tableObj1.list = list.length ? list : [];
          this[`tableObj${index}`].tableObj1.layerpageinfo.total =
            res.obj.totalSize;
        } else {
          this[`tableObj${index}`].tableObj2.list = list.length ? list : [];
          this[`tableObj${index}`].tableObj2.layerpageinfo.total =
            res.obj.totalSize;
        }
      });
    },
    // 子组件执行一次父组件的方法
    getList(flag) {
      this.getFontCosts(this.index, flag);
    },
    certified() {
      if (this.info.role === "UserRoleOrdinary") {
        this.isCertified = 2;
      } else if (this.info.role === "UserRoleEnterprise") {
        this.isCertified = 1;
        this.getFontCosts(this.index, true); //初始获取第一种类型的缴费列表
        this.getFontCosts(this.index, false); //初始获取第一种类型的缴费列表
      } else if (this.info.role === "UserRoleEmployee") {
        this.isCertified = 3;
      }
    },
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          console.log(this.info);

          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    //跳转员工认证
    toEmployeeCertify() {
      this.$router.push({ name: "employee_certification" });
    },
    //跳转企业认证
    toEnterpriseCertify() {
      this.$router.push({ name: "enterprise_certification" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../index.scss";
.park_payment {
  .payment_current {
    .payment_current_title {
      color: rgba(16, 16, 16, 1);
      font-size: 20px;
      line-height: 50px;
      margin-left: 20px;
    }
  }
  .payment_before {
    .payment_before_title {
      color: rgba(16, 16, 16, 1);
      font-size: 20px;
      line-height: 50px;
      margin-left: 20px;
    }
  }
  .message{
    color: #2e3c50;
    font-size: 14px;
  }
}
</style>
